import { useState, useEffect } from 'react';

export const useIsScrolled = (containerRef: React.RefObject<HTMLElement>) => {
	const [isScrolled, setIsScrolled] = useState(false);
	useEffect(() => {
		if (!containerRef.current) return;
		const container = containerRef.current;

		const sentinel = document.createElement('div');
		sentinel.style.position = 'absolute';
		sentinel.style.top = '0';
		sentinel.style.height = '1px';
		sentinel.style.width = '100%';
		sentinel.style.pointerEvents = 'none';

		container.prepend(sentinel);

		const observerCallback = (entries: IntersectionObserverEntry[]) => {
			const [entry] = entries;
			setIsScrolled(!entry.isIntersecting);
		};

		// eslint-disable-next-line no-restricted-syntax
		const observer = new IntersectionObserver(observerCallback, {
			root: container,
			threshold: 1.0,
		});

		observer.observe(sentinel);

		return () => {
			observer.disconnect();
			if (sentinel.parentElement) {
				sentinel.parentElement.removeChild(sentinel);
			}
		};
	}, [containerRef]);

	return isScrolled;
};
